import arTranslations from './translations.ar.js'

/**
 * UI strings: ar (Arabic), en (English).
 * Missing keys fall back to English (see getTranslation).
 */
export const translations = {
  en: {
    logoMark: 'AI Restro 360',
    nav: {
      merge: 'POS & ORDERS',
      split: 'KITCHEN & STOCK',
      compress: 'DELIVERY & GUESTS',
      convert: 'ANALYTICS & AI',
      login: 'Login',
      logIn: 'Log in',
      dashboard: 'Dashboard',
      signUp: 'Sign up',
      home: 'Home',
    },
    airestroHeader: {
      solutions: 'Solutions',
      integrations: 'Integrations',
      pricing: 'Pricing',
      resources: 'Resources',
      megaSolutions: 'Solutions',
      megaIntegrations: 'Integrations',
      megaResources: 'Resources',
      localeLabel: 'Language',
      solCol1: 'Front of house',
      solCol2: 'Kitchen & operations',
      solCol3: 'Delivery & loyalty',
      solCol4: 'Growth',
      sol1t: 'AI voice ordering',
      sol1s: 'Answer calls and write clean tickets to POS and kitchen.',
      sol2t: 'Table & QR ordering',
      sol2s: 'Guests order and pay from their phones at the table.',
      sol3t: 'Self-serve kiosk',
      sol3s: 'Cut queues with guided ordering that posts to the kitchen.',
      sol4t: 'Kitchen display',
      sol4s: 'Live tickets with one-tap status for the line and pass.',
      sol5t: 'Prep & queue',
      sol5s: 'Fire timing and prep boards on the same clock.',
      sol6t: 'Inventory signals',
      sol6s: 'Spot stock surprises before a busy night runs dry.',
      sol7t: 'Delivery sync',
      sol7s: 'One view for marketplace and first-party delivery.',
      sol8t: 'Loyalty & CRM',
      sol8s: 'Guest history and offers across counter and online.',
      sol9t: 'Analytics',
      sol9s: 'Daily reports — sales, riders, and what you wasted.',
      sol10t: 'Marketing AI',
      sol10s: 'Promo ideas tuned to your menu and dayparts.',
      sol11t: 'Reviews & reputation',
      sol11s: 'Respond faster with suggested, on-brand replies.',
      sol12t: 'Partner API',
      sol12s: 'Connect your warehouse or custom stack safely.',
      intCardKicker: 'INTEGRATIONS',
      intCardTitle: 'POS, kitchen, and delivery connected',
      intCardDesc: 'One operational timeline for counter, pass, and riders.',
      intCardCta: 'All integrations',
      intOurTitle: 'Our integrations',
      intPartnersTitle: 'Our partners',
      intMid1: 'POS systems',
      intMid2: 'Delivery marketplaces',
      intMid3: 'Online ordering',
      intMid4: 'On-site ordering',
      intMid5: 'Dispatch & routing',
      intMid6: 'Loyalty & CRM',
      intP1: 'Uber Eats',
      intP2: 'DoorDash',
      intP3: 'Square',
      intP4: 'Clover',
      intP5: 'Become a partner',
      intP6: 'Build your integration',
      resCol1: 'Education',
      resCol2: 'Support',
      resCol3: 'Company',
      res1: 'Blog',
      res2: 'Documentation',
      resCase: 'Case studies',
      res3: 'Product updates',
      resEvents: 'Events',
      res4: 'Help center',
      res5: 'FAQ',
      res6: 'Contact us',
      res7: 'About us',
      res8: 'Careers',
      res9: 'How it works',
      announceAria: 'Site announcements',
      announcePrev: 'Previous announcement',
      announceNext: 'Next announcement',
      announce1:
        'NEW — Run POS, kitchen, riders, and inventory from one screen. Start free for 30 days.',
      announce2:
        'No hardware required. Browser-based restaurant OS for fast food, cafes, and takeaway.',
      announce3:
        'Setup in one day — we build your menu, add your team, and you take the first order.',
      venueLabel: 'Venue',
      venuePrevAria: 'Previous location',
      venueNextAria: 'Next location',
      mobileMenuOpen: 'Open menu',
      mobileMenuClose: 'Close menu',
      legalInResources: 'Legal',
    },
    title: 'AI Restro 360 — restaurant OS for fast food',
    /** Home `<title>` and Open Graph; visible hero headline is `landing.heroTitle*` (semantic `<h1>`). */
    seoHeroH1: 'AI Restro 360 — restaurant OS for fast food',
    subtitle:
      'Cloud restaurant POS with kitchen display, rider tracking, inventory, and reports — one system for busy service.',
    selectPdf: 'Add files',
    orDrop: 'or drop them here',
    fromCloud: 'From cloud',
    otherSources: 'Other sources',
    fileProtection: '✓ File protection is active',
    addMoreFiles: 'Add more files',
    removeFile: 'Remove',
    dpi: 'DPI',
    imageQuality: 'Image quality',
    color: 'Color',
    colorNoChange: 'No change',
    colorGray: 'Gray',
    compress: 'Apply',
    compressing: 'Working…',
    resultReduced: 'The size has been reduced by',
    shareOrContinue: 'Share or continue',
    download: 'Download',
    preview: 'Preview',
    erase: 'Erase',
    restart: 'Restart',
    googleDrive: 'Google Drive',
    dropbox: 'Dropbox',
    email: 'Email',
    mailSubject: 'Your file is ready',
    mailBody: 'Download:',
    footer: '© 2026 – Powered by ApimsTec',
    footerProduct: 'PRODUCT',
    footerResources: 'RESOURCES',
    footerLegal: 'LEGAL',
    footerCompany: 'COMPANY',
    footerHome: 'Home',
    footerFeatures: 'Features',
    footerPricing: 'Pricing',
    footerFaq: 'FAQ',
    footerTools: 'Tools',
    footerSolutions: 'SOLUTIONS',
    footerBusiness: 'Business',
    footerEducation: 'Education',
    footerSecurity: 'Security',
    footerPress: 'Press',
    footerPrivacy: 'Privacy policy',
    footerTerms: 'Terms & conditions',
    footerDisclaimer: 'Disclaimer',
    footerCookies: 'Cookies',
    footerAbout: 'About us',
    footerContact: 'Contact us',
    footerBlog: 'Blog',
    footerOther: 'OTHER',
    footerCopyrightPrefix: '© AI Restro 360 2026 – ',
    footerPoweredBy: 'powered by Apimstec',
    footerLanguage: 'English',
    footerGetGooglePlay: 'GET IT ON Google Play',
    footerDownloadAppStore: 'Download on the App Store',
    footerDownloadMacStore: 'Download on the Mac App Store',
    footerMicrosoftStore: 'Microsoft Store',
    footerCopyrightFull: 'Copyright © 2026 AI Restro 360. All rights reserved.',
    footerAddressLine: 'Islamabad, Pakistan — restaurant OS for fast food, cafes, and takeaway.',
    footerRegionGlobal: 'Global',
    footerRegionAria: 'Select region',
    footerChatAria: 'Contact us',
    footerColResources: 'Resources',
    footerHelpCenter: 'Help center',
    footerDocumentation: 'Documentation',
    footerCaseStudies: 'Case studies',
    footerProductNews: 'Product updates',
    footerEvents: 'Events',
    footerCommunity: 'Community',
    footerCookiePolicy: 'Cookie policy',
    footerLegalAbout: 'Legal: About the company',
    footerColSolutions: 'Solutions',
    footerColIntegrations: 'Integrations',
    footerColFor: 'AI Restro 360 for',
    footerCareers: 'Careers',
    footerCustomerStories: 'Customer stories',
    footerNewsletter: 'Sign up for our newsletter',
    footerTermsOfService: 'Terms of service',
    footerPrivacyCookieNotice: 'Privacy & Cookie notice',
    footerSolSentinel: 'Sentinel',
    footerSolDeliveryApp: 'Delivery Manager App',
    footerSolDirect: 'Direct',
    footerSolDispatch: 'Dispatch',
    footerSolKiosk: 'Kiosk',
    footerSolTableOrdering: 'Table Ordering',
    footerSolQuestApp: 'Quest App',
    footerIntAll: 'All integrations',
    footerIntPos: 'POS systems',
    footerInt3p: '3P Marketplace',
    footerIntOnline: 'Online ordering',
    footerIntRetail: 'Retail',
    footerIntLoyalty: 'Loyalty & CRM',
    footerIntPartner: 'Become a partner',
    footerForRestaurants: 'Restaurants',
    footerForRetail: 'Retail',
    footerForEnterprise: 'Enterprise',
    ariaSelectPdf: 'Select files',
    ariaColorMode: 'Color mode',
    ariaRemove: 'Remove',
    compressionSettings: 'Processing settings',
    compressionResult: 'Result',
    progressInitializing: 'Initializing…',
    progressLoading: 'Loading…',
    progressPage: 'Processing…',
    progressFinalizing: 'Finalizing…',
    progressGrayscale: 'Applying options…',
    maxFilesReached: 'You already have the maximum of 10 files. Remove one to add another.',
    maxFilesPartial: 'Only the first files that fit were added (maximum 10).',
    maxFilesHint: 'Maximum 10 files per session.',
    fileCountHint: '{count} of {max} files selected',
    settingsRequiredHint: 'Complete the required options to continue.',
    fileDone: 'Done',
    compressFileProgress: 'File {current} of {total}: {name}',
    resultMultiTitle: 'Your files are ready',
    resultSavedSuffix: 'smaller',
    fromTheBlog: 'From the blog',
    viewAllPosts: 'View all posts',
    downloadAll: 'Download all',
    otherTools: 'Other tools',
    landing: {
      heroTitleLine1: 'Stop losing ',
      heroTitleAccent1: 'money',
      heroTitleLine2: ' every ',
      heroTitleAccent2: 'rush hour.',
      heroSubtitle:
        'Every missed order, every paper slip, every rider you cannot track costs you money. AI Restro 360 gives your restaurant one screen for POS, kitchen, riders, and inventory — live all day.',
      heroTrust: 'No credit card. No hardware. Setup in one day.',
      cineTitle: 'Rush Hour Season.',
      cineSubtitle:
        'Discover AI Restro 360 — POS, kitchen, and riders, on one screen. Made for the rush, and every shift after.',
      cineCtaTrial: 'Start Free Trial',
      cineCtaDemo: 'Book A Demo',
      cineOfferAria: 'Product announcement',
      cineOfferBefore: 'New — Farori, your AI assistant, is here.',
      cineOfferLogin: 'Log in',
      cineOfferOr: 'or',
      cineOfferStart: 'Start free',
      cinePauseVideo: 'Pause background video',
      cinePlayVideo: 'Play background video',
      ctaCompress: 'Start free — 30 days',
      featuresTitle: 'One system. Every moving part.',
      feature1Title: 'Rush hour chaos',
      feature1Desc:
        'Orders stack up, the kitchen loses track, riders wait, and wrong items go out. One live queue keeps everyone aligned.',
      feature2Title: 'Paper everywhere',
      feature2Desc:
        'Notebook tallies, WhatsApp screenshots, and handwritten slips hide the real numbers. See sales and waste in one place.',
      feature3Title: 'Riders you cannot track',
      feature3Desc:
        'Know who has which order and which cash was collected — every delivery logged, every rupee accounted for.',
      feature4Title: 'Stock surprises',
      feature4Desc:
        'Running out mid-service hurts more than a slow ticket. Inventory stays tied to what you actually sell.',
      howTitle: 'From zero to first order in one day',
      howStep1: 'Sign up free',
      howStep1Desc: 'Create your account in minutes. No payment, no card, no paperwork.',
      howStep2: 'We build your menu',
      howStep2Desc: 'Share your menu — we add every category, item, and price for you.',
      howStep3: 'Add your team',
      howStep3Desc: 'Set up cashier, kitchen, and rider accounts with clear roles in one click.',
      howStep4: 'Start taking orders',
      howStep4Desc: 'Open a browser. Your restaurant is live. First order in under five minutes.',
      faqButtonFallback: 'Question {n}',
      faqTitle: 'Common questions',
      faq1Q: 'Is there a free trial?',
      faq1A:
        'Yes — 30 days free with full feature access. No credit card required, and the trial does not auto-convert to a paid plan.',
      faq2Q: 'Do I need special hardware?',
      faq2A:
        'No. AI Restro 360 runs in the browser on any phone, tablet, or laptop. Use what you already have.',
      faq3Q: 'How fast can we go live?',
      faq3A:
        'Most venues go from signup to first live order in one day. We help with menu setup and team accounts.',
      faq4Q: 'Can I cancel anytime?',
      faq4A:
        'Monthly plans cancel anytime. Your data stays yours — export when you need it.',
      readyTitle: 'Ready to stop the rush-hour leaks?',
      readySubtitle: 'Start free for 30 days, or book a short demo with our team.',
      cmsSectionAria: 'Site introduction',
      arHeroEyebrow: 'Restaurant OS for fast food',
      arStatsAria: 'Key highlights',
      arStat1Value: 'Rs 0',
      arStat1Label: 'HARDWARE REQUIRED',
      arStat2Value: '1 day',
      arStat2Label: 'TIME TO GO LIVE',
      arStat3Value: '30 days',
      arStat3Label: 'FREE FULL ACCESS',
      arTestimonialQuote:
        'One screen for POS, kitchen, riders, and inventory — the floor and the back office finally agree.',
      arQuoteBadge: 'Built for busy service',
      arContactLink: 'Book a demo',
      arFaqSubtitle: 'Straight answers for owners and managers rolling out AI Restro 360.',
      arFaqCta: 'Contact us',
      arFaqViewAll: 'Jump to questions',
      arWhatTitle: 'What drains your P&L',
      arWhyTitle: 'Your restaurant bleeds money in ways you do not even notice.',
      arWhoTitle: 'Who this is for',
      arWho1Title: 'FAST FOOD & TAKEAWAY',
      arWho1Desc:
        'Counter service, delivery, and kitchen tickets in one flow — without a pile of paper slips.',
      arWho2Title: 'CAFES & TEA STALLS',
      arWho2Desc:
        'Simple POS, clear reports, and stock visibility that fits a small team and a busy counter.',
      arWho3Title: 'MULTI-BRANCH GROUPS',
      arWho3Desc:
        'Same playbook across locations — menus, roles, and end-of-day numbers that actually match.',
      arIntegrationsTitle: 'Works with how you already sell',
      arIntegrationsSub:
        'POS, kitchen display, riders, payments, and guest data stay on one operational timeline.',
      arIntLogo1: 'POS',
      arIntLogo2: 'Kitchen',
      arIntLogo3: 'Riders',
      arIntLogo4: 'Inventory',
      arIntLogo5: 'Reports',
      arDualTitle: 'Explore the platform & get help',
      arCtaCard1Title: 'SOLUTIONS',
      arCtaCard1Desc: 'See POS, kitchen, delivery, and growth modules built for real service.',
      arCtaCard2Title: 'TALK TO US',
      arCtaCard2Desc: 'Onboarding, multi-branch rollout, or a quick demo — we are ready to help.',
      arExploreLink: 'Explore',
      arGetStarted: 'Start free — 30 days',
      homePricingTitle: 'Simple monthly pricing for every branch',
      homePricingSub:
        'One USD price covers all your branches. Pick a ready stack or build your bill with the calculator.',
      guaranteeTitle: 'Zero-risk to get started',
      guarantee1Title: '30 days free',
      guarantee1Desc: 'Full feature access, no credit card, no commitment.',
      guarantee2Title: 'We set it up',
      guarantee2Desc: 'Menu added, team configured, system ready on day one.',
      guarantee3Title: 'No hardware',
      guarantee3Desc: 'Any phone, tablet, or laptop — just a browser.',
      guarantee4Title: 'Cancel anytime',
      guarantee4Desc: 'Month-to-month plans. Your data is always yours to export.',
    },
    tools: {
      pageTitle: 'Platform & solutions',
      frequentlyUsed: 'Popular',
      mergePdf: 'Point of sale',
      splitPdf: 'Kitchen & KDS',
      compressPdf: 'Delivery & marketplaces',
      editPdf: 'Menu & pricing',
      signPdf: 'Staff & shifts',
      convertPdf: 'Inventory & purchasing',
      imagesToPdf: 'Reservations',
      pdfToImages: 'Guest profiles',
      extractImages: 'Loyalty & CRM',
      protectPdf: 'Loss prevention',
      unlockPdf: 'Permissions & roles',
      rotatePdf: 'Table & QR order',
      removePages: 'Drive-thru & kiosk',
      extractPages: 'Catering & events',
      rearrangePages: 'Multi-site reporting',
      webpageToPdf: 'Marketing & campaigns',
      pdfOcr: 'Forecasting & AI',
      addWatermark: 'Branded receipts',
      addPageNumbers: 'Audit log',
      pdfOverlay: 'API & data export',
      comparePdfs: 'Benchmarking',
      webOptimize: 'Open integrations',
      redactPdf: 'Compliance & policies',
      createPdf: 'Onboarding',
      translatePdf: '24/7 support',
      jpgToPdf: 'Table management',
      wordToPdf: 'Payment routing',
      powerpointToPdf: 'Franchise tools',
      excelToPdf: 'Vendor catalog',
      htmlToPdf: 'Guest Wi‑Fi & reviews',
      pdfToJpg: 'In-store hardware',
      pdfToWord: 'Training mode',
      pdfToPowerpoint: 'Franchise ops',
      pdfToExcel: 'Costing',
      pdfToPdfa: 'Data residency',
    },
    megaMenu: {
      organizePdf: 'FRONT OF HOUSE',
      optimizePdf: 'KITCHEN OPS',
      convertToPdf: 'DELIVERY & GUESTS',
      convertFromPdf: 'GROWTH & LOYALTY',
      editPdf: 'INVENTORY',
      pdfSecurity: 'PERMISSIONS',
      pdfIntelligence: 'ANALYTICS & AI',
    },
    pricing: {
      title: 'Pricing',
      intro:
        'USD pricing for all branches. Start with POS Core, take the Full Stack, or mix add-ons — including AI Receptionist (Farori) at $19/mo.',
      ctaContact: 'Contact sales',
      ctaRegister: 'Get started',
    },
    about: {
      title: 'About AI Restro 360',
      intro:
        'We build a cloud restaurant operating system for fast food, cafes, and takeaway — so POS, kitchen, riders, and inventory stay on one screen.',
      ctaContact: 'Talk to us',
    },
    contact: {
      title: 'Contact',
      description: 'Get in touch with the AI Restro 360 team.',
      intro:
        'Ask about a demo, onboarding, multi-branch rollout, or support. We reply from Islamabad and work with restaurants across Pakistan and beyond.',
      detailsHeading: 'Contact details',
      sendAnother: 'Send another message',
      email: 'Email',
      phone: 'Phone',
      address: 'Address',
      backHome: 'Back to home',
      noDetails: 'Prefer email or WhatsApp? Reach us at support@airestro360.com or +92 301 2775034.',
      yourName: 'Your name',
      yourEmail: 'Your email',
      subject: 'Subject',
      chooseSubject: 'Choose a subject…',
      message: 'Message',
      writeMessage: 'How can we help?',
      iAccept: 'I accept',
      termsAndConditions: 'Terms & Conditions',
      legalPrivacy: 'Legal & Privacy',
      sendMessage: 'Send message',
      successMessage: 'Your message has been sent. We will get back to you soon.',
      errorSend: 'Unable to send message. Please try again.',
      errorTerms: 'You must accept the Terms & Conditions and Legal & Privacy to send the form.',
      subjectGeneral: 'General inquiry',
      subjectSupport: 'Support',
      subjectFeedback: 'Feedback',
      subjectOther: 'Other',
    },
    notFound: {
      title: 'Page not found',
      body: 'The page you are looking for does not exist or has been moved.',
      backHome: 'Back to home',
    },
    cookieConsent: {
      title: 'Your privacy matters',
      body: 'We use cookies to run this site and improve our services. Choose essential cookies only, or accept all.',
      policyLink: 'Cookie policy',
      necessaryOnly: 'Essential only',
      acceptAll: 'Accept all',
    },
    breadcrumb: {
      result: 'Result',
      page: 'Page',
      legal: 'Legal',
      solutions: 'Solutions',
      integrations: 'Integrations',
      resources: 'Resources',
    },
    blog: {
      listTitle: 'Blog',
      listIntro:
        'Guides and product notes for restaurant owners — POS, kitchen flow, delivery, and running a tighter service.',
      readMore: 'Read more',
      noPosts: 'No blog posts yet.',
      emptyTitle: 'No articles yet',
      emptyBody:
        'New posts are on the way. Check back for restaurant ops tips, product updates, and practical hospitality insights.',
      backHome: 'Back to home',
      backToBlog: 'Back to blog',
    },
  },
  ar: arTranslations,
}

/** Public site default: English at `/`; Arabic at `/ar/…`. */
export const defaultLang = 'en'

export const supportedLangs = ['en', 'ar']

/** URL prefix: empty for English (default), `/ar` for Arabic. */
export function langPrefix(lang) {
  return lang === defaultLang ? '' : `/${lang}`
}

const OG_LOCALE_MAP = {
  ar: 'ar_SA',
  en: 'en_US',
}

export function langToOgLocale(lang) {
  return OG_LOCALE_MAP[lang] || lang || ''
}

/** Strings always resolve from English if missing in the active locale. */
const TRANSLATION_FALLBACK = 'en'

/** User-chosen UI language (persists across visits; survives refresh). */
const LOCALE_STORAGE_KEY = 'restro360_user_locale'

/** Legacy session hint from old geo detection — migrated once into localStorage. */
const LOCALE_HINT_KEY = 'restro360_locale_hint'
const LOCALE_HINT_TTL_MS = 7 * 24 * 60 * 60 * 1000

export function readUserLocalePreference() {
  if (typeof localStorage === 'undefined') return null
  try {
    const raw = localStorage.getItem(LOCALE_STORAGE_KEY)
    if (!raw) return null
    const lang = String(raw).trim().toLowerCase()
    /** Legacy Indonesian locale → Arabic (replaced May 2026). */
    if (lang === 'id') {
      try {
        localStorage.setItem(LOCALE_STORAGE_KEY, 'ar')
      } catch {
        /* ignore */
      }
      return 'ar'
    }
    return supportedLangs.includes(lang) ? lang : null
  } catch {
    return null
  }
}

export function writeUserLocalePreference(lang) {
  if (typeof localStorage === 'undefined') return
  if (!supportedLangs.includes(lang)) return
  try {
    localStorage.setItem(LOCALE_STORAGE_KEY, lang)
  } catch {
    /* private mode / quota */
  }
}

export function readLocaleHintCache() {
  if (typeof sessionStorage === 'undefined') return null
  try {
    const raw = sessionStorage.getItem(LOCALE_HINT_KEY)
    if (!raw) return null
    const { lang, t } = JSON.parse(raw)
    if (typeof lang !== 'string' || typeof t !== 'number') return null
    if (Date.now() - t > LOCALE_HINT_TTL_MS) {
      sessionStorage.removeItem(LOCALE_HINT_KEY)
      return null
    }
    const norm = String(lang).trim().toLowerCase()
    if (norm === 'id') return 'ar'
    return supportedLangs.includes(norm) ? norm : null
  } catch {
    return null
  }
}

export function writeLocaleHintCache(lang) {
  if (typeof sessionStorage === 'undefined') return
  if (!supportedLangs.includes(lang)) return
  try {
    sessionStorage.setItem(LOCALE_HINT_KEY, JSON.stringify({ lang, t: Date.now() }))
  } catch {
    /* private mode */
  }
}

/** Language option for dropdown: flag emoji + label */
export const langOptions = {
  ar: { flag: '🇸🇦', label: 'العربية' },
  en: { flag: '🇬🇧', label: 'English' },
}

/** Map full browser locale tags to app lang (ISO 639-1). */
const BROWSER_LANG_ALIASES = {
  ar: 'ar',
  'ar-sa': 'ar',
  'ar-ae': 'ar',
  'ar-eg': 'ar',
  'ar-ma': 'ar',
  'en-us': 'en',
  'en-gb': 'en',
}

/**
 * Browser language list only (no geo cache). Used inside async geo resolver.
 */
export function getPreferredLangFromBrowser() {
  if (typeof navigator === 'undefined') return defaultLang
  const locales = navigator.languages && navigator.languages.length
    ? navigator.languages
    : [navigator.language]
  for (const locale of locales) {
    const full = (locale || '').toLowerCase().replace(/_/g, '-')
    if (BROWSER_LANG_ALIASES[full]) return BROWSER_LANG_ALIASES[full]
    const code = full.split('-')[0]
    if (BROWSER_LANG_ALIASES[code]) return BROWSER_LANG_ALIASES[code]
    if (supportedLangs.includes(code)) return code
  }
  return defaultLang
}

/**
 * Preferred lang for redirects / invalid URL recovery:
 * 1) explicit user choice (localStorage)
 * 2) one-time migration from legacy session geo hint
 * 3) default English (no IP lookup — fast first paint)
 */
export function getPreferredLang() {
  if (typeof window === 'undefined') return defaultLang
  const stored = readUserLocalePreference()
  if (stored) return stored
  const legacy = readLocaleHintCache()
  if (legacy) {
    writeUserLocalePreference(legacy)
    try {
      sessionStorage.removeItem(LOCALE_HINT_KEY)
    } catch {
      /* ignore */
    }
    return legacy
  }
  return defaultLang
}

export function getTranslation(lang, keyPath) {
  const langData = translations[lang] ?? translations[TRANSLATION_FALLBACK]
  const keys = keyPath.split('.')
  let value = langData
  for (const k of keys) {
    value = value?.[k]
  }
  if (value !== undefined && value !== null) return value
  if (lang !== TRANSLATION_FALLBACK) return getTranslation(TRANSLATION_FALLBACK, keyPath)
  return keyPath
}
